// extracted by mini-css-extract-plugin
export default {"notificationsStroke":"fp0Xw","notificationsFill":"_2d639"};